export const viewPermissionMap = {
    '/': 'sensitivity_parameters',
    '/sales/summary': 'sales_summary',
    '/sales/configuration': 'sales_configuration',
    '/finca/summary': 'farm_summary',
    '/finca/configuration': 'farm_configuration',
    '/shopping/summary': 'shopping_summary',
    '/shopping/configuration': 'shopping_configuration',
    '/planta-solidos/summary': 'solid_summary',
    '/planta-solidos/configuration': 'solid_configuration',
    '/planta-latex/summary': 'latex_summary',
    '/planta-latex/configuration': 'latex_configuration',
    '/logistica/summary': 'logistics_and_export_summary',
    '/logistica/configuration': 'logistics_and_export_configuration',
    '/administrativos/summary': 'administrative_summary',
    '/administrativos/configuration': 'administrative_configuration',
    '/deuda/summary': 'debt_management_summary',
    '/deuda/configuration': 'debt_management_configuration',
    '/inversiones/summary': 'investments_summary',
    '/inversiones/configuration': 'investments_configuration',
    '/credito-fiscal/summary': 'tax_credit_summary'
};
